var _path, _path2, _g, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgIconArrowRight(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "#9196AF",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_99_3004)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_99_3004",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 16,
    height: 16
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0 0H16V16H0V0Z"
  }))), /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_99_3004)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask1_99_3004",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 16,
    height: 17
  }, _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0.000732422H16V16.0007H0V0.000732422Z"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask1_99_3004)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M5.51076 14.3895L12.1197 8.84399C12.576 8.46106 12.6357 7.7808 12.2528 7.32458C11.87 6.86837 11.1898 6.80896 10.7334 7.19189L4.12448 12.7374C3.66812 13.1204 3.6085 13.8006 3.99131 14.2568C4.37412 14.7131 5.0544 14.7725 5.51076 14.3895Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12.1197 7.16908L5.51082 1.62353C5.05446 1.2406 4.37418 1.30001 3.99137 1.75623C3.60856 2.21244 3.66818 2.8927 4.12454 3.27563L10.7335 8.82118C11.1898 9.20411 11.8701 9.1447 12.2529 8.68848C12.6357 8.23227 12.5761 7.552 12.1197 7.16908Z"
  }))))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_99_3004"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 16,
    height: 16
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconArrowRight);
export default __webpack_public_path__ + "static/media/icon-arrow-right.49dcd4506bcbe2fa30e1424f1ca486c0.svg";
export { ForwardRef as ReactComponent };